var AchBankAccountStatuses = {
    LINKED: 'LINKED',
    UNLINKED: 'UNLINKED',
    DELETED: 'DELETED',
};
var isBankAccount = function (value) {
    return (value !== null &&
        typeof value === 'object' &&
        'numberMask' in value &&
        typeof value.numberMask === 'string' &&
        value.numberMask.length > 0 &&
        'issuingBank' in value &&
        typeof value.issuingBank === 'string' &&
        value.issuingBank.length > 0 &&
        'id' in value &&
        typeof value.id === 'number' &&
        !isNaN(value.id) &&
        'preferred' in value &&
        typeof value.preferred === 'boolean' &&
        'name' in value &&
        typeof value.name === 'string' &&
        value.name.length > 0 &&
        'status' in value &&
        typeof value.status === 'string' &&
        Object.keys(AchBankAccountStatuses).includes(value.status)
    // TODO: Include once supportedOrderTypes is in core prod: https://github.com/AfterpayTouch/rocketship/pull/2566 - (1/2)
    // && 'supportedOrderTypes' in value &&
    // Array.isArray(value.supportedOrderTypes)
    );
};

export { AchBankAccountStatuses, isBankAccount };
